import { Textarea } from '@chakra-ui/react';

export const OpenQuestion = () => {
  return (
    <Textarea
      placeholder="Answer goes here..."
      isDisabled
      _hover={{}}
      resize="none"
      bg="#fff"
      border="1px solid"
      borderColor="border-color"
      fontSize="12px"
      _placeholder={{
        color: 'secondary-500',
      }}
      opacity="1 !important"
    />
  );
};
